import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import { getConfig } from '../configuracao/configLocal';

import TooltipWrapper from '../common/form/TooltipWrapper';
import ProcessingOverlay from '../common/components/processingOverlay';

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

const dateInputStyle = {
  width: '150px',
  height: '32px',
  padding: '4px 8px',
  fontSize: '12px',
  border: '1px solid #bfd0e0',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  color: '#475569',
};

class LogAdaptativoList extends Component {
  carregaColunas() {
    const { list } = this.props;

    const columns = [
      {
        Header: 'Data',
        accessor: 'data',
        minWidth: 100,
        maxWidth: 120,
        style: { fontSize: '12px', textAlign: 'center' },
        Cell: props => (props.original.tipo === 'normal' ? String(props.value || '') : ''),
        filterable: false,
        resizable: true,
        sortable: true,
        className: 'column_grid column_center',
        sortMethod: (a, b, desc) => {
          // Usar timestamp para ordenação mais precisa
          const aTimestamp = a.original ? a.original.timestamp_original : 0;
          const bTimestamp = b.original ? b.original.timestamp_original : 0;
          const aKey = a.original ? a.original.ordenacao_key : '';
          const bKey = b.original ? b.original.ordenacao_key : '';

          // Se for o mesmo timestamp (mesmo ciclo), usar ordenacao_key para manter ordem das linhas
          if (aTimestamp === bTimestamp) {
            if (aKey < bKey) return -1;
            if (aKey > bKey) return 1;
            return 0;
          }

          // Para diferentes timestamps, aplicar ordenação
          // Por padrão (desc=false), mais recente no topo (timestamp maior primeiro)
          // Quando desc=true, mais antigo no topo (timestamp menor primeiro)
          if (desc) {
            return aTimestamp - bTimestamp; // Crescente (mais antigo primeiro)
          } else {
            return bTimestamp - aTimestamp; // Decrescente (mais recente primeiro)
          }
        },
      },
      {
        Header: 'Hora',
        accessor: 'hora',
        minWidth: 80,
        maxWidth: 100,
        style: { fontSize: '12px', textAlign: 'center' },
        Cell: props => (props.original.tipo === 'normal' ? String(props.value || '') : ''),
        filterable: false,
        resizable: true,
        sortable: false,
        className: 'column_grid column_center',
      },
      {
        Header: 'Plano',
        accessor: 'plano',
        minWidth: 60,
        maxWidth: 80,
        filterable: false,
        style: { fontSize: '12px', textAlign: 'center' },
        Cell: props => (props.original.tipo === 'normal' ? String(props.value || '') : ''),
        sortable: false,
      },
      {
        Header: 'Modo Operação',
        accessor: 'modo_operacao',
        minWidth: 160,
        filterable: false,
        style: { fontSize: '12px', textAlign: 'center' },
        sortable: false,
        Cell: props => {
          if (props.original.tipo !== 'normal') return '';

          const modoOperacao = props.original.modo_operacao;
          if (!modoOperacao) return '';

          // Garantir que sempre renderizamos uma string
          let textoModoOperacao = '';

          if (typeof modoOperacao === 'object') {
            textoModoOperacao = modoOperacao.descricao || modoOperacao.nome || String(modoOperacao.id || '');
          } else {
            textoModoOperacao = String(modoOperacao);
          }

          return (
            <span
              style={{
                fontSize: '12px',
                color: '#000',
              }}
            >
              {textoModoOperacao}
            </span>
          );
        },
      },
      {
        Header: 'Tipo',
        accessor: 'tipo_label',
        minWidth: 155,
        filterable: false,
        style: { fontSize: '12px', textAlign: 'center' },
        sortable: false,
        Cell: props => {
          const tipo = props.original.tipo;
          const tipoLabel = props.value || props.original.tipo_label;
          const teveAtuacao = tipo === 'executado' && this.teveAtuacaoAdaptativa(props.original);

          let bg = '#e9e9e9'; // default
          if (tipo === 'normal') bg = '#d8d8d8';
          // mais escuro
          else if (tipo === 'maximo') bg = '#e6e6e6';
          // médio
          else if (tipo === 'executado') bg = teveAtuacao ? '#e8f4fc' : '#f3f3f3';

          return (
            <span
              className={teveAtuacao ? 'log-adaptativo-tipo-atuado' : ''}
              title={teveAtuacao ? 'Houve extensão adaptativa neste ciclo' : undefined}
              style={{
                padding: '4px 8px',
                borderRadius: '6px',
                fontSize: '12px',
                backgroundColor: bg,
                color: teveAtuacao ? '#1e5a7a' : '#000',
                fontWeight: teveAtuacao ? 600 : 400,
              }}
            >
              {teveAtuacao && <span className="log-adaptativo-atuacao-dot" aria-hidden="true" />}
              {String(tipoLabel || '')}
            </span>
          );
        },
      },
    ];

    // Descobrir quais intervalos são adaptativos baseado nos dados
    const intervalosAdaptativos = this.getIntervalosAdaptativos(list);
    // Criar array de colunas apenas para os intervalos adaptativos
    const intervalosColumns = [];
    intervalosAdaptativos.forEach(numeroIntervalo => {
      const apenasNumeroIntervalo = parseInt(numeroIntervalo);
      intervalosColumns.push({
        Header: `Int. ${apenasNumeroIntervalo}`,
        accessor: `intervalo_${apenasNumeroIntervalo}`,
        minWidth: 50,
        maxWidth: 70,
        style: { fontSize: '11px', textAlign: 'center' },
        sortable: false,
        filterable: false,
        Cell: props => {
          if (!props.original.intervalos) return '';

          const intervalo = props.original.intervalos.find(int => int.numero === apenasNumeroIntervalo);
          if (!intervalo) return '';

          const valor = props.original.tipo === 'maximo' ? intervalo.tempo_programado : intervalo.tempo_executado;
          const modoIntervalo = intervalo.modo;
          const valorNumerico = parseInt(valor, 10) || 0;
          const celulaAtuada =
            props.original.tipo === 'executado' && valorNumerico > 0;

          // Para linha de tempos normais, mostrar apenas o tempo sem modo
          if (props.original.tipo === 'normal') {
            return (
              <div
                style={{
                  textAlign: 'center',
                  fontFamily: 'monospace',
                }}
              >
                {parseInt(intervalo.tempo_programado) || 0}s
              </div>
            );
          }

          // Descrição e cor do modo
          const modoDescricao =
            {
              p: 'Adaptativo Coletivo',
              i: 'Atuado Adap. Individual',
              I: 'Adaptativo Individual',
              a: 'Atuado Adap. Coletivo',
              A: 'Atuado Adap. Coletivo (Maiúsculo)',
              N: 'Tempo Normal',
              // Adicione outros modos conforme necessário
            }[modoIntervalo] || 'Desconhecido';

          return (
            <TooltipWrapper tooltipText={modoDescricao}>
              <div
                className={celulaAtuada ? 'log-adaptativo-intervalo-atuado' : ''}
                style={{
                  textAlign: 'center',
                  fontFamily: 'monospace',
                }}
              >
                {valorNumerico}s{' - '} {modoIntervalo}
              </div>
            </TooltipWrapper>
          );
        },
      });
    });

    // Adicionar colunas dos intervalos adaptativos diretamente (sem agrupamento)
    if (intervalosColumns.length > 0) {
      columns.push(...intervalosColumns);
    }

    // Adicionar coluna T. Sobra
    columns.push({
      Header: 'T. Sobra',
      accessor: 'tempo_sobra',
      minWidth: 70,
      maxWidth: 90,
      filterable: false,
      style: { fontSize: '11px', textAlign: 'center' },
      sortable: false,
      Cell: props => {
        // Só calcular para linha executado
        if (props.original.tipo !== 'executado') return '';

        if (!props.original.intervalos || !Array.isArray(props.original.intervalos)) return '0s';

        try {
          // Soma dos tempos programados com validação
          const somaProgramado = props.original.intervalos.reduce((sum, int) => {
            if (!int || typeof int !== 'object') return sum;
            const tempo = parseInt(int.tempo_programado) || 0;
            return sum + tempo;
          }, 0);

          // Soma dos tempos executados com validação
          const somaExecutado = props.original.intervalos.reduce((sum, int) => {
            if (!int || typeof int !== 'object') return sum;
            const tempo = parseInt(int.tempo_executado) || 0;
            return sum + tempo;
          }, 0);

          const sobra = somaProgramado - somaExecutado;

          // Verificar se o resultado é um número válido
          if (isNaN(sobra)) {
            console.warn('Valor NaN detectado na coluna T. Sobra:', {
              somaProgramado,
              somaExecutado,
              intervalos: props.original.intervalos,
            });
            return '0s';
          }

          return (
            <span
              style={{
                fontSize: '12px',
                color: '#000',
              }}
            >
              {sobra}s
            </span>
          );
        } catch (error) {
          console.error('Erro ao calcular T. Sobra:', error);
          return '0s';
        }
      },
    });

    // Adicionar coluna T. T. Ciclo (tempo programado do ciclo)
    columns.push({
      Header: 'T. T. Ciclo',
      accessor: 'tempo_ciclo',
      minWidth: 70,
      maxWidth: 90,
      filterable: false,
      style: { fontSize: '11px', textAlign: 'center' },
      sortable: false,
      Cell: props => {
        // Só mostrar para linha executado
        if (props.original.tipo !== 'executado') return '';

        // Usar o tempo_programado do backend com validação
        const tempoProgramado = parseInt(props.original.tempo_programado) || 0;

        // Verificar se é um número válido
        if (isNaN(tempoProgramado)) {
          console.warn('Valor NaN detectado na coluna T. T. Ciclo:', props.original.tempo_programado);
          return '0s';
        }

        return (
          <span
            style={{
              fontSize: '12px',
              color: '#000',
            }}
          >
            {tempoProgramado}s
          </span>
        );
      },
    });

    // Adicionar coluna Tempo Total do Ciclo
    columns.push({
      Header: 'T. Ciclo Executado',
      accessor: 'tempo_total_ciclo',
      minWidth: 90,
      maxWidth: 130,
      filterable: false,
      style: { fontSize: '11px', textAlign: 'center' },
      sortable: false,
      Cell: props => {
        // Só mostrar para linha executado
        if (props.original.tipo !== 'executado') return '';

        // Usar o dado que vem do backend com validação
        const tempoTotal = parseInt(props.original.tempo_total_ciclo) || 0;

        // Verificar se é um número válido
        if (isNaN(tempoTotal)) {
          console.warn('Valor NaN detectado na coluna T. Ciclo Executado:', props.original.tempo_total_ciclo);
          return '0s';
        }

        return (
          <span
            style={{
              fontSize: '12px',
              color: '#000',
            }}
          >
            {tempoTotal}s
          </span>
        );
      },
    });

    return columns;
  }

  // Função para descobrir quais intervalos são adaptativos baseado nos dados
  getIntervalosAdaptativos = dados => {
    if (!dados || !Array.isArray(dados) || dados.length === 0) {
      return [];
    }

    const intervalosAdaptativos = new Set();

    dados.forEach(ciclo => {
      if (ciclo.intervalos && Array.isArray(ciclo.intervalos)) {
        ciclo.intervalos.forEach(intervalo => {
          if (intervalo.numero && intervalo.modo) {
            intervalosAdaptativos.add(intervalo.numero);
          }
        });
      }
    });

    // Converter Set para Array e ordenar numericamente
    return Array.from(intervalosAdaptativos).sort((a, b) => a - b);
  };

  // Função para processar os dados e criar três linhas por ciclo (normal, programado, executado)
  processarDados = dados => {
    const dadosProcessados = [];

    dados.forEach((ciclo, index) => {
      try {
        // Validar dados básicos do ciclo
        if (!ciclo || typeof ciclo !== 'object') {
          console.warn('Ciclo inválido detectado:', ciclo);
          return;
        }

        // Garantir que campos essenciais são strings
        const dataValidada = String(ciclo.data || '');
        const horaValidada = String(ciclo.hora || '');
        const planoValidado = String(ciclo.plano || '');

        // Recalcular status do ciclo baseado na nova interpretação
        const statusRecalculado = this.recalcularStatusCiclo(ciclo);

        // Criar um identificador único para ordenação que mantém as três linhas juntas
        // Usar timestamp para ordenação mais precisa (mais recente no topo por padrão)
        const timestamp = new Date(
          `${dataValidada
            .split('/')
            .reverse()
            .join('-')} ${horaValidada}`,
        ).getTime();

        // Verificar se timestamp é válido
        if (isNaN(timestamp)) {
          console.warn('Timestamp inválido para ciclo:', { data: dataValidada, hora: horaValidada });
          return;
        }

        // Criar chave de ordenação: timestamp_invertido para mais recente ficar no topo + índice para garantir ordem
        const timestampInvertido = 9999999999999 - timestamp; // Inverter para mais recente ficar no topo
        const ordenacaoKey = `${String(timestampInvertido).padStart(15, '0')}_${String(index).padStart(6, '0')}`;

        // Criar intervalos com tempos normais
        const intervalosNormais = [];
        ciclo.intervalos.forEach(intervalo => {
          const tempoNormal = parseFloat(intervalo.tempo_normal) || 0;
          if (tempoNormal > 0) {
            // Só adiciona se tem tempo normal
            intervalosNormais.push({
              numero: intervalo.numero,
              modo: 'N', // Modo Normal
              tempo_programado: tempoNormal,
              tempo_executado: 0, // Não aplicável para tempos normais
              extensao: 0,
            });
          }
        });

        dadosProcessados.push({
          ...ciclo,
          data: dataValidada,
          hora: horaValidada,
          plano: planoValidado,
          tipo: 'normal',
          tipo_label: 'Tempo Normal',
          intervalos: intervalosNormais, // pode estar vazio
          dadosOriginais: ciclo,
          cicloIndex: index, // Para colorir as linhas
          ordenacao_key: `${ordenacaoKey}_0`, // Garante que linha normal vem primeiro
          data_original: dataValidada, // Preserva data original para ordenação
          timestamp_original: timestamp, // Para ordenação
        });

        // Linha 2: Tempos programados (sem dados redundantes)
        dadosProcessados.push({
          ...ciclo,
          data: '', // Vazio para evitar redundância
          hora: '', // Vazio para evitar redundância
          plano: '', // Vazio para evitar redundância
          modo_operacao: { descricao: '' }, // Vazio para evitar redundância
          tipo: 'maximo',
          tipo_label: 'Tempo Ext. Programado',
          dadosOriginais: ciclo,
          cicloIndex: index, // Para colorir as linhas
          ordenacao_key: `${ordenacaoKey}_1`, // Garante que linha programado vem depois
          data_original: dataValidada, // Preserva data original para ordenação
          timestamp_original: timestamp, // Para ordenação
        });

        // Linha 3: Tempos executados (sem dados redundantes)
        dadosProcessados.push({
          ...ciclo,
          data: '', // Vazio para evitar redundância
          hora: '', // Vazio para evitar redundância
          plano: '', // Vazio para evitar redundância
          modo_operacao: { descricao: '' }, // Vazio para evitar redundância
          tipo: 'executado',
          tipo_label: 'Tempo Ext. Executado',
          dadosOriginais: ciclo,
          cicloIndex: index, // Para colorir as linhas
          status_ciclo: statusRecalculado, // Usar status recalculado
          ordenacao_key: `${ordenacaoKey}_2`, // Garante que linha executado vem por último
          data_original: dataValidada, // Preserva data original para ordenação
          timestamp_original: timestamp, // Para ordenação
        });
      } catch (error) {
        console.error('Erro ao processar ciclo:', error, ciclo);
      }
    });

    return dadosProcessados;
  };

  // Função para recalcular o status do ciclo baseado na nova interpretação
  recalcularStatusCiclo = ciclo => {
    if (!ciclo.intervalos || ciclo.intervalos.length === 0) return 'Normal';

    const statusIntervalos = ciclo.intervalos.map(intervalo => {
      // Se tempo executado for 0, consideramos normal (não houve extensão)
      if (intervalo.tempo_executado === 0) {
        return 'normal';
      }

      // Só há extensão se tempo executado > 0 (nunca há redução)
      const tempoExecutado = intervalo.tempo_executado || 0;
      if (tempoExecutado > 0) return 'extensão';
      return 'normal';
    });

    const temExtensao = statusIntervalos.includes('extensão');
    return temExtensao ? 'Extensão' : 'Normal';
  };

  teveAtuacaoAdaptativa = row => {
    if (!row || !Array.isArray(row.intervalos)) return false;
    return row.intervalos.some(int => (parseInt(int.tempo_executado, 10) || 0) > 0);
  };

  getModoOperacaoTexto = row => {
    const modoOperacao = row.modo_operacao;
    if (!modoOperacao) return '';
    if (typeof modoOperacao === 'object') {
      return modoOperacao.descricao || modoOperacao.nome || String(modoOperacao.id || '');
    }
    return String(modoOperacao);
  };

  getIntervaloCellTexto = (row, numeroIntervalo) => {
    if (!row.intervalos) return '';
    const intervalo = row.intervalos.find(int => int.numero === numeroIntervalo);
    if (!intervalo) return '';

    if (row.tipo === 'normal') {
      return `${parseInt(intervalo.tempo_programado, 10) || 0}s`;
    }

    const valor = row.tipo === 'maximo' ? intervalo.tempo_programado : intervalo.tempo_executado;
    return `${parseInt(valor, 10) || 0}s - ${intervalo.modo || ''}`;
  };

  getTipoCellPrintHtml = row => {
    const tipo = row.tipo;
    const tipoLabel = row.tipo_label || '';
    const teveAtuacao = tipo === 'executado' && this.teveAtuacaoAdaptativa(row);

    let bg = '#e9e9e9';
    if (tipo === 'normal') bg = '#d8d8d8';
    else if (tipo === 'maximo') bg = '#e6e6e6';
    else if (tipo === 'executado') bg = teveAtuacao ? '#e8f4fc' : '#f3f3f3';

    const color = teveAtuacao ? '#1e5a7a' : '#000';
    const fontWeight = teveAtuacao ? '600' : '400';
    const dot = teveAtuacao
      ? '<span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:#4aa3df;box-shadow:0 0 0 2px rgba(74,163,223,0.25);margin-right:6px;flex-shrink:0;"></span>'
      : '';

    return `<span style="display:inline-flex;align-items:center;padding:4px 8px;border-radius:6px;background:${bg};color:${color};font-weight:${fontWeight};">${dot}${escapeHtml(tipoLabel)}</span>`;
  };

  getIntervaloCellPrintHtml = (row, numeroIntervalo) => {
    const texto = this.getIntervaloCellTexto(row, numeroIntervalo);
    if (!texto) return '';

    if (row.tipo !== 'executado') {
      return escapeHtml(texto);
    }

    const intervalo = row.intervalos && row.intervalos.find(int => int.numero === numeroIntervalo);
    const valorNumerico = intervalo ? parseInt(intervalo.tempo_executado, 10) || 0 : 0;

    if (valorNumerico > 0) {
      return `<span style="color:#1e5a7a;font-weight:600;font-family:monospace;">${escapeHtml(texto)}</span>`;
    }

    return escapeHtml(texto);
  };

  getRowPrintAttrs = row => {
    const cicloIndex = row.cicloIndex;
    const isEvenCycle = cicloIndex % 2 === 0;
    const teveAtuacao = row.tipo === 'executado' && this.teveAtuacaoAdaptativa(row);

    if (teveAtuacao) {
      return {
        className: 'row-atuado',
        style: `background:${isEvenCycle ? '#eef6fb' : '#f5faff'};`,
      };
    }

    return {
      className: '',
      style: `background:${isEvenCycle ? '#f9f9f9' : '#ffffff'};`,
    };
  };

  imprimirRelatorio = () => {
    const { list, dataInicio, dataFim, agrupador } = this.props;
    const controladorId = getConfig('cont');
    const numeroControlador = getConfig('numCont') || controladorId;

    if (!controladorId || controladorId === 0) {
      alert('Selecione um controlador para imprimir.');
      return;
    }

    const dadosProcessados = list && list.length > 0 ? this.processarDados(list) : [];
    if (!dadosProcessados.length) {
      alert('Nenhum dado para imprimir com os filtros atuais.');
      return;
    }

    const intervalosAdaptativos = this.getIntervalosAdaptativos(list);
    const agrupadorLabel =
      {
        0: 'Sem agrupamento',
        5: '5 min',
        10: '10 min',
        15: '15 min',
        30: '30 min',
        60: '60 min',
      }[agrupador] || 'Sem agrupamento';

    let printWindow = null;
    try {
      printWindow = window.open('', '_blank');
      if (!printWindow) {
        alert('Não foi possível abrir a janela de impressão. Verifique o bloqueador de pop-ups.');
        return;
      }

      let headCols = `
        <th>Data</th>
        <th>Hora</th>
        <th>Plano</th>
        <th>Modo Operação</th>
        <th>Tipo</th>
      `;
      intervalosAdaptativos.forEach(num => {
        headCols += `<th>Int. ${num}</th>`;
      });
      headCols += `
        <th>T. Sobra</th>
        <th>T. T. Ciclo</th>
        <th>T. Ciclo Executado</th>
      `;

      let rowsHtml = '';
      dadosProcessados.forEach(row => {
        const rowAttrs = this.getRowPrintAttrs(row);

        let cols = `
          <td>${escapeHtml(row.data || row.data_original || '')}</td>
          <td>${escapeHtml(row.hora || (row.dadosOriginais && row.dadosOriginais.hora) || '')}</td>
          <td>${escapeHtml(row.plano || '')}</td>
          <td>${escapeHtml(this.getModoOperacaoTexto(row))}</td>
          <td>${this.getTipoCellPrintHtml(row)}</td>
        `;

        intervalosAdaptativos.forEach(num => {
          cols += `<td>${this.getIntervaloCellPrintHtml(row, num)}</td>`;
        });

        let tempoSobra = '';
        let tempoCiclo = '';
        let tempoTotal = '';
        if (row.tipo === 'executado' && Array.isArray(row.intervalos)) {
          const somaProgramado = row.intervalos.reduce(
            (sum, int) => sum + (parseInt(int.tempo_programado, 10) || 0),
            0,
          );
          const somaExecutado = row.intervalos.reduce(
            (sum, int) => sum + (parseInt(int.tempo_executado, 10) || 0),
            0,
          );
          tempoSobra = `${somaProgramado - somaExecutado}s`;
          tempoCiclo = `${parseInt(row.tempo_programado, 10) || 0}s`;
          tempoTotal = `${parseInt(row.tempo_total_ciclo, 10) || 0}s`;
        }

        cols += `
          <td>${escapeHtml(tempoSobra)}</td>
          <td>${escapeHtml(tempoCiclo)}</td>
          <td>${escapeHtml(tempoTotal)}</td>
        `;
        rowsHtml += `<tr class="${rowAttrs.className}" style="${rowAttrs.style}">${cols}</tr>`;
      });

      const html = `
        <html>
          <head>
            <title>Histórico Adaptativo - Controlador ${escapeHtml(numeroControlador)}</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; color: #333; font-size: 11px; }
              h2 { margin-bottom: 8px; }
              p { margin: 4px 0; }
              table { width: 100%; border-collapse: collapse; margin-top: 16px; }
              th, td { border: 1px solid #ddd; padding: 6px; text-align: center; }
              th { background: #f2f2f2; font-weight: bold; }
              tr.row-atuado td:first-child { border-left: 3px solid #4aa3df; }
              @media print {
                tr.row-atuado td:first-child { border-left: 3px solid #4aa3df !important; }
                tr.row-atuado { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
              }
            </style>
          </head>
          <body>
            <h2>Histórico Adaptativo</h2>
            <p><strong>Controlador:</strong> ${escapeHtml(numeroControlador)}</p>
            <p><strong>Período:</strong> ${escapeHtml(moment(dataInicio).format('DD/MM/YYYY'))} a ${escapeHtml(moment(dataFim).format('DD/MM/YYYY'))}</p>
            <p><strong>Agrupamento:</strong> ${escapeHtml(agrupadorLabel)}</p>
            <p><strong>Registros:</strong> ${dadosProcessados.length}</p>
            <table>
              <thead><tr>${headCols}</tr></thead>
              <tbody>${rowsHtml}</tbody>
            </table>
          </body>
        </html>
      `;

      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();
      setTimeout(() => {
        try {
          printWindow.print();
        } catch (e) {}
        try {
          printWindow.close();
        } catch (e) {}
      }, 50);
    } catch (error) {
      console.error('Erro ao imprimir histórico adaptativo:', error);
      if (printWindow && !printWindow.closed) {
        try {
          printWindow.close();
        } catch (e) {}
      }
      alert('Erro ao gerar impressão. Tente novamente.');
    }
  };

  renderDateToolbar() {
    const { dataInicio, dataFim, onDateRangeChange } = this.props;
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <label style={{ fontSize: '12px', color: '#64748b', margin: 0, fontWeight: 600 }}>De</label>
        <input
          type="date"
          value={dataInicio || ''}
          onChange={e => onDateRangeChange && onDateRangeChange('dataInicio', e.target.value)}
          style={dateInputStyle}
        />
        <label style={{ fontSize: '12px', color: '#64748b', margin: 0, fontWeight: 600 }}>Até</label>
        <input
          type="date"
          value={dataFim || ''}
          onChange={e => onDateRangeChange && onDateRangeChange('dataFim', e.target.value)}
          style={dateInputStyle}
        />
      </div>
    );
  }

  render() {
    const { list, loading, error } = this.props;
    const columns = this.carregaColunas();
    const controladorId = getConfig('cont');

    // Verificar se há controlador selecionado
    if (!controladorId || controladorId === 0) {
      return (
        <div className="table-container" style={{ marginTop: '20px', textAlign: 'center', padding: '40px' }}>
          <div style={{ color: '#666', fontSize: '18px' }}>
            <i className="fa fa-info-circle" style={{ marginRight: '10px', fontSize: '20px' }} />
            Selecione um controlador para visualizar os logs de extensões adaptativas
          </div>
        </div>
      );
    }

    const dadosProcessados = list && list.length > 0 ? this.processarDados(list) : [];

    return (
      <div className="table-container" style={{ marginTop: '20px', width: '100%' }}>
        <ProcessingOverlay
          show={loading}
          message={
            <>
              Carregando histórico adaptativo...
              <small>Aguarde enquanto os registros são consultados.</small>
            </>
          }
          tagline="Histórico Adaptativo"
        />

        {error ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ color: '#d9534f', fontSize: '18px' }}>
              <i className="fa fa-exclamation-circle" style={{ marginRight: '10px', fontSize: '20px' }} />
              Erro ao carregar dados: {error}
            </div>
          </div>
        ) : !loading && (!list || list.length === 0) ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ color: '#666', fontSize: '18px' }}>
              <i className="fa fa-inbox" style={{ marginRight: '10px', fontSize: '20px' }} />
              Nenhum log de extensão encontrado para este controlador
            </div>
          </div>
        ) : (
          <>
        <style>{`
          .log-adaptativo-premium-table .ReactTable .rt-th.column_center,
          .log-adaptativo-premium-table .ReactTable .rt-td.column_center {
            justify-content: center;
            text-align: center;
          }

          .log-adaptativo-premium-table .ReactTable .rt-th .rt-resizable-header-content,
          .log-adaptativo-premium-table .ReactTable .rt-th .rt-th-content {
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .log-adaptativo-premium-table .ReactTable .rt-td,
          .log-adaptativo-premium-table .ReactTable .rt-th {
            font-size: 12px;
          }

          .log-adaptativo-premium-table .ReactTable .rt-tr.log-adaptativo-row-atuado {
            box-shadow: inset 3px 0 0 #4aa3df;
          }

          .log-adaptativo-tipo-atuado {
            display: inline-flex;
            align-items: center;
            gap: 6px;
          }

          .log-adaptativo-atuacao-dot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #4aa3df;
            box-shadow: 0 0 0 2px rgba(74, 163, 223, 0.25);
            flex-shrink: 0;
          }

          .log-adaptativo-intervalo-atuado {
            color: #1e5a7a;
            font-weight: 600;
          }
        `}</style>

        <div className="log-adaptativo-premium-table">
          <PremiumTableShell
            summary={`${dadosProcessados.length} linha(s) exibida(s)`}
            toolbarRight={this.renderDateToolbar()}
            tableMinWidth={0}
          >
            <ReactTableGT2A
              data={dadosProcessados}
              columns={columns}
              defaultPageSize={30}
              showPagination
              filterable={false}
              defaultSorted={[
                {
                  id: 'data',
                  desc: false,
                },
              ]}
              style={{
                fontSize: '13px',
                width: '100%',
              }}
              className="-striped -highlight responsive-table"
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.original) {
                  const cicloIndex = rowInfo.original.cicloIndex;
                  const isEvenCycle = cicloIndex % 2 === 0;
                  const teveAtuacao =
                    rowInfo.original.tipo === 'executado' &&
                    this.teveAtuacaoAdaptativa(rowInfo.original);

                  return {
                    className: teveAtuacao ? 'log-adaptativo-row-atuado' : '',
                    style: {
                      backgroundColor: teveAtuacao
                        ? isEvenCycle
                          ? '#eef6fb'
                          : '#f5faff'
                        : isEvenCycle
                          ? '#f9f9f9'
                          : '#ffffff',
                    },
                  };
                }
                return {};
              }}
              resizable={false}
            />
          </PremiumTableShell>
        </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.logAdaptativo.list,
  loading: state.logAdaptativo.loading,
  error: state.logAdaptativo.error,
});

export default connect(mapStateToProps, null, null, { withRef: true })(LogAdaptativoList);
